import { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import LogosMarquee from "@/components/LogosMarquee";
import ManifestoSection from "@/components/ManifestoSection";
import FeaturesBento from "@/components/FeaturesBento";
import ProductShowcase from "@/components/ProductShowcase";
import StatsSection from "@/components/StatsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FaqSection from "@/components/FaqSection";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import FilmGrain from "@/components/FilmGrain";
import { Toaster } from "sonner";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.2,
    });
    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const rafId = requestAnimationFrame(raf);

    // Expose for GSAP ScrollTrigger integration
    window.__lenis = lenis;

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App film-grain min-h-screen bg-[#050507] text-[#F4F4F2]" data-testid="app-root">
      <FilmGrain />
      <Navbar />
      <main>
        <HeroSection />
        <LogosMarquee />
        <ManifestoSection />
        <FeaturesBento />
        <ProductShowcase />
        <StatsSection />
        <TestimonialsSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0b0c10",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#f4f4f2",
          },
        }}
      />
    </div>
  );
}

export default App;
